import React, { useState, Fragment } from 'react';
import styles from './compare.module.scss';
import Select, {components} from 'react-select';
import { dataConvertOverview } from '../../utils/overall-convert';
import { educ2Overview } from '../../data/data-education-tab2';
import { formatNumberWithDot } from '../../utils/utils';
import CountryFlag from '../common/countryFlag/country-flag';
import ProgressBar from '../common/progressBar/progress-bar.module';
import SelectDropdown from '../common/selectDropdown/select-dropdown';
import { useIsMobile900 } from '../../hooks/mobile';
import IconSort from '../common/icon/icon-sort';
import ReverseIconSort from '../common/icon/reverse-icon-sort';
import IconDelete from '../common/icon/icon-delete';
import IconSearch from '../common/icon/icon-search';

const options = [
  { label: "Total opportunity score", value: "total" },
  { label: "Earning potential", value: "project" },
  { label: "Career advancement", value: "career" },
  { label: "Top-tier employment prospects", value: "employ" },
  { label: "Premium education", value: "edu" },
  { label: "Economic mobility", value: "econ" },
  { label: "High livability", value: "liva" },
];

const dropDownIndicator = (props) => {
  return (
    components.DropdownIndicator && (
      <components.DropdownIndicator {...props}>
          <IconSearch />
      </components.DropdownIndicator>
    )
  );
};


const Compare = () => {

  const [sortColumn, setSortColumn] = useState("total");
  // const [display, setDisplay] = useState();
  // const [countryCount, setCountryCount] = useState(1);
  const [projectCount, setProjectCount] = useState(1);
  const [careerCount, setCareerCount] = useState(1);  
  const [employCount, setEmployCount] = useState(1);
  const [eduCount, setEduCount] = useState(1);
  const [econCount, setEconCount] = useState(1);
  const [livaCount, setLivaCount] = useState(1);
  const [totalCount, setTotalCount] = useState(1);
  
  const [passportSelected, setPassportSelected] = useState("");
  // const countryList = educ2Overview.map((c) => c.country);
  const [countrySelectedList, setCountrySelectedList] = useState([]);

  
  const isMobile = useIsMobile900();

  


  const dataEduc2Overview = () => {
    return dataConvertOverview(educ2Overview);
  }

  const handleOptionSelect = (option) => {
    // setSelectedOption(option);
    setSortColumn(option.value);
    // setDisplay(-1);
  };

  const handleSort = (columnName) => {
    switch (columnName) {
      // case 'country':
      //   (countryCount === 1) ? setCountryCount(-1) : setCountryCount(1);
      //   break;
      case 'project':
        (projectCount === 1) ? setProjectCount(-1) : setProjectCount(1);
        break;
      case 'career':
        (careerCount === 1) ? setCareerCount(-1) : setCareerCount(1);
        break;
      case 'employ':
        (employCount === 1) ? setEmployCount(-1) : setEmployCount(1);
        break;
      case 'edu':
        (eduCount === 1) ? setEduCount(-1) : setEduCount(1);
        break;
      case 'econ':
        (econCount === 1) ? setEconCount(-1) : setEconCount(1);
        break;
      case 'liva':
        (livaCount === 1) ? setLivaCount(-1) : setLivaCount(1);
        break;
      case 'total':
        (totalCount === 1) ? setTotalCount(-1) : setTotalCount(1);
        break;
      default:
        break;
    }

    setSortColumn(columnName);
    // setDisplay(-1);

  };

  const reverseSortNum = (columnName, count) => {
    if (count === 1) {
      return dataEduc2Overview().sort((a, b) => b[columnName] - a[columnName]);
    }
    return dataEduc2Overview().sort((a, b) => a[columnName] - b[columnName]);
  }

  const handleSortingOptions = (columnName, countryName) => {
    switch (columnName) {
      // case 'country':
        // return sortedData.filter((t) => t.country !== countryName);
      //   return (countryCount === 1) ?
      //     dataEduc2Overview().sort((a, b) => b[columnName].localeCompare(a[columnName]))
      //     : dataEduc2Overview().sort((a, b) => a[columnName].localeCompare(b[columnName]));
      case 'project':
        return reverseSortNum(columnName, projectCount);
      case 'career':
        return reverseSortNum(columnName, careerCount);
      case 'employ':
        return reverseSortNum(columnName, employCount);
      case 'edu':
        return reverseSortNum(columnName, eduCount);
      case 'econ':
        return reverseSortNum(columnName, econCount);
      case 'liva':
        return reverseSortNum(columnName, livaCount);
      case 'total':
        return reverseSortNum(columnName, totalCount);
      default:
        break;
    }
  }


  // const handleMobileRowClick = (index) => {
  //   setDisplay(index);
  // }

  // const handleShowHideList = () => {
  //   setHideList(!hideList);
  //   setNumOfCitiesShow(numOfCitiesShow === 10 ? `${sortedData.length}` : 10);
  // };


  const passportSelectStyles = {
    menu: (provided) => ({
      ...provided,
      zIndex: 100,
      backgroundColor:'#fff',
      borderRadius: 0,
      paddingLeft: 10,
      paddingRight: 10
    }),
    control: (provided) => ({
      ...provided,
      background: "transparent",
      border: "none",
      boxShadow: "none",
      borderRadius: 0,
      color: "#405363",
      padding:0,
      borderBottom: "1px solid #979797"
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      color: "#405363",
      padding: isMobile ? 14 : 12,
    }),
    placeholder: (provided) => ({
      ...provided,
      color: "#405363",
      fontFamily: "Garamond Regular",
      fontSize: isMobile ? 14: 16,
    //   paddingLeft: 16,
    }),
    indicatorSeparator: (provided) => ({
      ...provided,
      display: "none",
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "#405363",
      fontFamily: "Garamond Regular",
      fontSize: isMobile ? 14 : 16,
    //   paddingLeft: 10,
    }),
    valueContainer: (provided) => ({
      ...provided,
      padding: "0 0 8px 0",
      
    }),
    indicatorsContainer: (provided) => ({
      ...provided,
      // background: "#f7f7f7",
    }),
    option: (provided, state) => ({
      ...provided,
      fontSize: isMobile ? 14 : 18,
      backgroundColor: state.isFocused
        ? "#C1C5C8"
        : state.isDisabled
        ? "#f3f3f3"
        : null,
      color: state.isFocused
        ? "#405363"
        : state.isDisabled
        ? "#405363"
        : "",
      opacity: state.isDisabled
        ? "0.5"
        : "1",
      cursor: state.isDisabled
        ? 'not-allowed'
        : 'pointer'
    }),
  };
  

  
  const getDisabledOptions = (c) => {
    return (countrySelectedList) ? countrySelectedList.includes(c) : false;
  };

  const passportOptions = () =>{
    let optionData = [];
    optionData = sortedData;
    
    
    return optionData.map((t)=>({
        label: (t.im) ? t.country + '*' : t.country, 
        country: t.country, 
        value: t.total,
        // isDisabled: type === 'compare' ? getDisabledOptions().includes(passport.code) : false
        // isDisabled: getDisabledOptions().includes(t.country)
        isDisabled: getDisabledOptions(t.country)

    }));
}


  const handlePassportSelect = (selectedOption) =>{
    setPassportSelected(selectedOption);

    if(selectedOption){
      const selectedItem = sortedData.find((t) => t.country === selectedOption.country);
      
      // const selectedPassportData = sortedData.find(
      //     (d) => d.country === selectedOption.value
      // );
      const updatedList = [...countrySelectedList, selectedOption.country];
      setCountrySelectedList(updatedList);
      
      if (selectedItem) {
          // sortedData = [...sortedData, selectedItem];
          // const updatedList = countrySelectedList.push(selectedOption.country);
          // setCountrySelectedList(updatedList);
          setPassportSelected("");
      }

    }

    
  }
  
  const handlePassportSelectBlur = () =>{
    
    setPassportSelected("");
  }
  
  const handleDeleteFromTable = (country) => {
    const updatedList = countrySelectedList.filter((t) => t !== country);
    setCountrySelectedList(updatedList);
    setPassportSelected("");

  };

  
  const sortedData = sortColumn
    ? handleSortingOptions(sortColumn)
    : dataEduc2Overview();

  
  const tableData = sortedData.filter((t) => countrySelectedList.includes(t.country));

  return (
    <>
      {/* <h3 className="mb-5">The Henley Opportunity Index</h3> */}
      <div className={`d-md-none ${styles.sortMobileWrapper}`}>
        <div className={styles.sortTitle}>Sort by</div>
        <SelectDropdown options={options} onSelect={handleOptionSelect} />
      </div>
      <table className={`chartTable ${styles.overviewChartTable}`} >
        <thead>
          <tr>
            {/* <th className={styles.cityColumn} >City/Area</th> */}
            {/* <th className={styles.cityColumn} >Country</th> */}
            <th className={`${styles.selectBoxWrapper} ${styles.cityColumn}`}>
              <Select
                value={passportSelected}
                options={passportOptions()}
                onChange={handlePassportSelect}
                onBlur={handlePassportSelectBlur}
                isClearable
                isSearchable
                // menuIsOpen
                placeholder="Search for countries"
                components={{ DropdownIndicator:dropDownIndicator}}
                blurInputOnSelect={true}
                // isOptionDisabled={(option) => option.isDisabled}
                styles={passportSelectStyles}
              />
            </th>

            {/* <th
              className={`text-left ${styles.cellHideMobile} ${styles.countryColumn} ${styles.sortableColumn} ${sortColumn === 'country' ? styles.selectedColumn : ''}`}
              onClick={() => handleSort("country")}
            >
              <div className={styles.sortColumnTitle}>
                {(countryCount === 1) ? <IconSort /> : <ReverseIconSort />}
                <span className={styles.sortColumnTitleText}>Country</span>
              </div>
            </th> */}

            <th
              className={
                `text-right 
                              ${styles.cellHideMobile}
                              ${styles.sortableColumn} 
                              ${styles.progressBarColumn}
                              ${sortColumn === 'total' ? styles.selectedColumn : ''}
                              ${sortColumn === 'total' ? styles.displayColumnTitleDiv : ''}
              `}
              onClick={() => handleSort("total")}
            >
              <div className={styles.sortColumnTitle}>
                <span className={styles.sortColumnTitleText}>Total opportunity score</span>
                {(totalCount === 1) ? <IconSort /> : <ReverseIconSort />}
              </div>
            </th>
            <th
              className={
                `text-right 
                              ${styles.cellHideMobile}
                              ${styles.sortableColumn} 
                              ${styles.dataColumn}
                              ${sortColumn === 'project' ? styles.selectedColumn : ''}
                              ${sortColumn === 'project' ? styles.displayColumnTitleDiv : ''}
              `}
              onClick={() => handleSort("project")}
            >
              <div className={styles.sortColumnTitle}>
                <span className={styles.sortColumnTitleText}>Earning potential</span>
                {(projectCount === 1) ? <IconSort /> : <ReverseIconSort />}
              </div>
            </th>
            <th
              className={
                `text-right   
                              ${styles.cellHideMobile}
                              ${styles.sortableColumn}  
                              ${styles.dataColumn}
                              ${sortColumn === 'career' ? styles.selectedColumn : ''}
                              ${sortColumn === 'career' ? styles.displayColumnTitleDiv : ''}

              `}
              onClick={() => handleSort("career")}
            >
              <div className={styles.sortColumnTitle}>
                <span className={styles.sortColumnTitleText}>Career advancement</span>
                {(careerCount === 1) ? <IconSort /> : <ReverseIconSort />}

              </div>
            </th>
            <th
              className={
                `text-right 
                              ${styles.cellHideMobile}
                              ${styles.sortableColumn} 
                              ${styles.dataColumn}
                              ${sortColumn === 'employ' ? styles.selectedColumn : ''}
                              ${sortColumn === 'employ' ? styles.displayColumnTitleDiv : ''}
              `}
              onClick={() => handleSort("employ")}
            >
              <div className={styles.sortColumnTitle}>
                <span className={styles.sortColumnTitleText}>Top-tier employment prospects</span>
                {(employCount === 1) ? <IconSort /> : <ReverseIconSort />}
              </div>
            </th>
            <th
              className={
                `text-right   
                              ${styles.cellHideMobile}
                              ${styles.sortableColumn}  
                              ${styles.dataColumn}
                              ${sortColumn === 'edu' ? styles.selectedColumn : ''}
                              ${sortColumn === 'edu' ? styles.displayColumnTitleDiv : ''}

              `}
              onClick={() => handleSort("edu")}
            >
              <div className={styles.sortColumnTitle}>
                <span className={styles.sortColumnTitleText}>Premium education</span>
                {(eduCount === 1) ? <IconSort /> : <ReverseIconSort />}

              </div>
            </th>
            
            <th
              className={
                `text-right 
                              ${styles.cellHideMobile}
                              ${styles.sortableColumn} 
                              ${styles.dataColumn}
                              ${sortColumn === 'econ' ? styles.selectedColumn : ''}
                              ${sortColumn === 'econ' ? styles.displayColumnTitleDiv : ''}
              `}
              onClick={() => handleSort("econ")}
            >
              <div className={styles.sortColumnTitle}>
                <span className={styles.sortColumnTitleText}>Economic mobility</span>
                {(econCount === 1) ? <IconSort /> : <ReverseIconSort />}
              </div>
            </th>
            <th
              className={
                `text-right   
                              ${styles.cellHideMobile}
                              ${styles.sortableColumn}  
                              ${styles.dataColumn}
                              ${sortColumn === 'liva' ? styles.selectedColumn : ''}
                              ${sortColumn === 'liva' ? styles.displayColumnTitleDiv : ''}

              `}
              onClick={() => handleSort("liva")}
            >
              <div className={styles.sortColumnTitle}>
                <span className={styles.sortColumnTitleText}>High livability</span>
                {(livaCount === 1) ? <IconSort /> : <ReverseIconSort />}

              </div>
            </th>
            

            {/* <th className={`text-right ${styles.cellHideMobile}`}>Investment <br/>migration options</th> */}
          </tr>
        </thead>
        <tbody>
          {tableData.map((item, index) => (
          // {sortedData.slice(0, numOfCitiesShow).map((item, index) => (
            <Fragment key={index}>
              <tr className={`${styles.contentRow} ${styles.openedRow}`}>
                {/* <tr onClick={() => handleMobileRowClick(index)} className={`${styles.contentRow} ${index === display ? styles.openedRow : ''}`}> */}
                {/* <td>{item.city}</td> */}
                
                <td >
                  <div className="d-flex align-items-center">
                    <button className={styles.deleteRowButton} onClick={() => handleDeleteFromTable(item.country)}>
                      <IconDelete />
                    </button>
                    <CountryFlag country={item.country} classname={styles.noMarginCountryFlag}/>
                    {item.im && ' *'}
                  </div>
                </td>
                {/* <td className={`text-left 
                                ${styles.cellHideMobile} 
                                ${styles.sortableColumn} 
                                ${sortColumn === 'country' ? styles.selectedColumn : ''}
                              `}>
                  <CountryFlag country={item.country} />
                </td> */}
                
                <td className={`text-right 
                                ${styles.cellHideMobile} 
                                ${styles.sortableColumn} 
                                ${styles.cellOnMobile} 
                                ${sortColumn === 'total' ? styles.percentColumn : ''}
                                ${sortColumn === 'total' ? styles.selectedColumn : ''}
                              `}>
                  <ProgressBar
                    percentValue={item.total > 0 ? item.total : 0}
                    labelText={formatNumberWithDot(item.total) + "%"}
                  />
                </td>

                <td className={`text-right 
                                            ${styles.hiddenTableRow} 
                                            ${styles.sortableColumn} 
                                            ${styles.combinateRowCells} 
                                            ${sortColumn ? styles.selectedColumn : ''} 
                                            ${sortColumn === 'total' ? styles.percentColumn : ''}
                                          `}>
                  {sortColumn === "total" ?
                    <ProgressBar
                      percentValue={item.total > 0 ? item.total : 0}
                      labelText={formatNumberWithDot(item.total) + "%"}
                    />
                    : formatNumberWithDot(item[sortColumn])
                  }
                </td>
                
                <td className={`text-right 
                                ${styles.cellHideMobile} 
                                ${styles.sortableColumn} 
                                ${styles.cellOnMobile} 
                                ${sortColumn === 'project' ? styles.selectedColumn : ''}
                              `}>
                  {formatNumberWithDot(item.project)}
                </td>
                <td className={`text-right 
                                ${styles.cellHideMobile} 
                                ${styles.sortableColumn} 
                                ${styles.cellOnMobile} 
                                ${sortColumn === 'career' ? styles.selectedColumn : ''}
                              `}>
                  {formatNumberWithDot(item.career)}
                </td>
                <td className={`text-right 
                                ${styles.cellHideMobile} 
                                ${styles.sortableColumn} 
                                ${styles.cellOnMobile} 
                                ${sortColumn === 'employ' ? styles.selectedColumn : ''}
                              `}>
                  {formatNumberWithDot(item.employ)}
                </td>
                <td className={`text-right 
                                ${styles.cellHideMobile} 
                                ${styles.sortableColumn} 
                                ${styles.cellOnMobile} 
                                ${sortColumn === 'edu' ? styles.selectedColumn : ''}
                              `}>
                  {formatNumberWithDot(item.edu)}
                </td>
                <td className={`text-right 
                                ${styles.cellHideMobile} 
                                ${styles.sortableColumn} 
                                ${styles.cellOnMobile} 
                                ${sortColumn === 'econ' ? styles.selectedColumn : ''}
                              `}>
                  {formatNumberWithDot(item.econ)}
                </td>
                <td className={`text-right 
                                ${styles.cellHideMobile} 
                                ${styles.sortableColumn} 
                                ${styles.cellOnMobile} 
                                ${sortColumn === 'liva' ? styles.selectedColumn : ''}
                              `}>
                  {formatNumberWithDot(item.liva)}
                </td>
                

                {/* <td className={`text-right ${styles.cellHideMobile}`}>
                                  {item.link && (
                                      <a href={item.link} target="_blank" className={styles.linkText} rel="noreferrer">Find out more</a>
                                  )}
                                  
                              </td> */}
              </tr>
              {/* <tr className={`${styles.hiddenTableRow}`}>
                <td className={`${styles.countryMobileDiv}`}>
                  <CountryFlag country={item.country} />
                </td>
              </tr> */}

            </Fragment>
          ))}


        </tbody>
      </table>


      <div className="footer-note mt-5">
        {/* <ul>
          <li>Figures for June 2023.</li>
          <li>Only includes individuals living in each city (residents).</li>
          <li>'Centi-millionaires' refers to individuals with investable wealth of USD 100 million or more.</li>
        </ul> */}
        <p>*Country/territory with an investment migration offering</p>
      </div>
    </>
  )
}

export default Compare;